export default function UserMessage({ message, variant }) {
  return (
    <div className={`user-message ${variant}`}>
      <p>{message}</p>
    </div>
  );
}
